// src/modules/competition/pages/StatisticsPage/index.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import StatisticsView from '../../components/StatisticsView';
import { useCompetitionStats } from '../../hooks/useCompetitionStats';
import Loading from '../../../../shared/components/Loading';
import { useWarmupTimer } from '../../../../shared/hooks/useWarmupTimer';

const StatisticsPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { stats, isLoading, error } = useCompetitionStats(id);
    const { isWarmup } = useWarmupTimer(isLoading);

    if (isLoading) return <Loading isWarmup={isWarmup} />;

    if (error) {
        return (
            <Container className="mt-4">
                <div className="alert alert-danger">Error: {error}</div>
            </Container>
        );
    }

    if (!stats) {
        return (
            <Container className="mt-4">
                <div className="alert alert-info">No statistics available</div>
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <Button
                variant="outline-secondary"
                size="sm"
                className="mb-3"
                onClick={() => navigate(`/competition/${id}`)}
            >
                &larr; Back to Competition
            </Button>
            <StatisticsView {...stats} />
        </Container>
    );
};

export default StatisticsPage;
